import Vue from 'vue'

import { Layout, HeaderLayout, FooterLayout } from './views/Layout'
import Claims from '@/views/Claims/Claims.vue'
import PriceLists from '@/views/PriceLists/PriceLists.vue'
import Styleguide from '@/views/Styleguide/Styleguide.vue'
import DetailPage from '@/views/DetailPage/DetailPage.vue'
import DepartmentContacts from '@/views/DepartmentContacts/DepartmentContacts.vue'
import Contacts from '@/views/Contacts/Contacts.vue'
import ContactsCard from '@/views/Contacts/components/Card.vue'
import KeyHighlights from '@/views/KeyHighlights/KeyHighlights.vue'
import KeyDocuments from '@/views/KeyDocuments/KeyDocuments.vue'
import ColoredCards from '@/views/ColoredCards/ColoredCards.vue'
import Certificates from '@/views/Certificates/Certificates.vue'
import CertificatesCheck from '@/views/CertificatesCheck/CertificatesCheck.vue'
import Products from '@/views/Products/Products.vue'
import ProductsDetail from '@/views/ProductsDetail/ProductsDetail.vue'
import DetailPagePrevNextControls from '@/views/DetailPagePrevNextControls/DetailPagePrevNextControls.vue'
import MainPage from '@/views/MainPage/MainPage.vue'
import Page404 from '@/views/Page404/Page404.vue'
import ContactsPage from '@/views/ContactsPage/ContactsPage.vue'

Vue.component('layout', Layout)
Vue.component('header-layout', HeaderLayout)
Vue.component('footer-layout', FooterLayout)
Vue.component('claims', Claims)
Vue.component('price-lists', PriceLists)
Vue.component('styleguide', Styleguide)
Vue.component('detail-page', DetailPage)
Vue.component('department-contacts', DepartmentContacts)
Vue.component('contacts', Contacts)
Vue.component('contacts-card', ContactsCard)
Vue.component('key-highlights', KeyHighlights)
Vue.component('key-documents', KeyDocuments)
Vue.component('colored-cards', ColoredCards)
Vue.component('certificates', Certificates)
Vue.component('certificates-check', CertificatesCheck)
Vue.component('products', Products)
Vue.component('products-detail', ProductsDetail)
Vue.component('detail-page-prev-next-controls', DetailPagePrevNextControls)
Vue.component('main-page', MainPage)
Vue.component('page-404', Page404)
Vue.component('contacts-page', ContactsPage)
